import { Icon } from '@tallink/components-lib'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import * as Vouchers from '../../../utils/vouchers'
import s from './VoucherEntry.module.scss'

export default function VoucherEntry({ voucher, onRemoveVoucher }) {
  const { t } = useTranslation()
  const hint = t('voucherPanel.voucher.hint', {
    amountLeft: voucher.amountLeft,
    expirationDate: voucher.expirationDate
  })

  // TODO: not sure if we need to check Vouchers.isCoupon(voucher) for showing hint
  return (
    <div className={s['voucher-entry']}>
      <div className={classNames(s['voucher-info'], s.applied)}>
        <span>{t('voucherPanel.voucher.label')}: </span>
        <span className={s['voucher-value']}>{voucher.code}</span>
      </div>
      {Vouchers.isCoupon(voucher) && (
        <div className={s.help}>
          <Icon size="s" type="question" />
          <div className={s.hint}>
            <div className={s.text} dangerouslySetInnerHTML={{ __html: hint }} />
          </div>
        </div>
      )}
      <button className={s.remove} onClick={onRemoveVoucher}>
        <Icon type="cross" />
      </button>
    </div>
  )
}

VoucherEntry.propTypes = {
  onRemoveVoucher: PropTypes.func.isRequired,
  voucher: PropTypes.shape({
    code: PropTypes.string,
    type: PropTypes.string,
    amountLeft: PropTypes.number,
    expirationDate: PropTypes.string
  })
}
